import { Tab, Tabs, tabsClasses } from "@mui/material";
import { FilteringCategory } from "../../../../../../domain/model/Category";
import { CustomCardView } from "../../../../../component/CustomCardView";
import { CustomTextView } from "../../../../../component/CustomTextView";
import {
  COLOR_LESS_BLACK,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../../../../data/colors/Colors";

interface p {
  selectedCategories: Array<FilteringCategory>;
  selectedTabIndex: number;
  handleChange: (event: React.SyntheticEvent, newValue: number) => void;
}

export function SelectedCategoriesTabsView(p: p) {
  return (
    <Tabs
      value={p.selectedTabIndex}
      onChange={p.handleChange}
      variant="scrollable"
      scrollButtons="auto"
      aria-label="scrollable auto tabs example"
      TabIndicatorProps={{
        style: {
          background: "transparent",
        },
      }}
      sx={{
        [`& .${tabsClasses.scrollButtons}`]: {
          "&.Mui-disabled": { opacity: 0.3 },
        },
      }}
    >
      {p.selectedCategories.map((c, index) => {
        return (
          <Tab
            key={index}
            label={
              <CustomCardView
                padding={2}
                width={"100%"}
                borderRadius={20}
                background={
                  index === p.selectedTabIndex
                    ? COLOR_LESS_BLACK
                    : COLOR_VERY_LIGHT_GRAY
                }
                children={
                  <CustomTextView
                    text={c.title}
                    textAlign="center"
                    fontWeight={index === p.selectedTabIndex ? "bold" : "300"}
                    fontSize={index === p.selectedTabIndex ? 22 : 18}
                    textColor={
                      index === p.selectedTabIndex
                        ? COLOR_WHITE
                        : COLOR_LESS_BLACK
                    }
                    props={{
                      transition: "all 0.2s ease-in-out",
                    }}
                  />
                }
              />
            }
            sx={{
              p: 0,
              m: 0.2,
              borderRadius: 20,
              height: 70,
            }}
          />
        );
      })}
    </Tabs>
  );
}
